import { render } from "./ViewTransfer.vue?vue&type=template&id=50e41134&scoped=true"
import script from "./ViewTransfer.vue?vue&type=script&lang=js"
export * from "./ViewTransfer.vue?vue&type=script&lang=js"

import "./ViewTransfer.vue?vue&type=style&index=0&id=50e41134&scoped=true&lang=css"

import exportComponent from "/Users/tinypocket/workspace/joysun/repositories/jb/jb-ems-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50e41134"]])

export default __exports__